import e, { useMemo as m } from "react";
import { Overlay as f } from "../../../Overlay/Overlay.js";
import { OverflowContent as i } from "./OverflowContent.js";
import { OverflowHighlightedSection as u } from "./OverflowHighlightedSection.js";
import "@olxbr/ds-icons";
import "../../../../../Lurker/Lurker.js";
import { getABTestVariant as p } from "../../../../../../helpers/ab.js";
const c = _ref => {
  let {
    wrapperRef: n,
    openSubMenu: a,
    accountInfo: o,
    fixed: d,
    hasNavbar: r
  } = _ref;
  const {
      userName: l
    } = o,
    t = m(() => p("m-pro-bdg") === "enabled", []);
  return e.createElement(e.Fragment, null, e.createElement(f, {
    open: a
  }), e.createElement("ul", {
    id: "ds-overflow-menu",
    "aria-hidden": !a,
    "data-expanded": a,
    "data-fixed": d,
    "data-islogged": !!l,
    "data-hasnavbar": r,
    ref: n,
    "data-testid": "overflow-menu",
    className: "olx-header__overflow olx-header__overflow--no-border-top"
  }, e.createElement(u, {
    accountInfo: o,
    hasNavbar: r,
    openSubMenu: !!a,
    enableNewBadge: t
  }), e.createElement(i, {
    accountInfo: o,
    hasNavbar: r,
    openSubMenu: a,
    enableNewBadge: t
  })));
};
export { c as ProOverflowMenu };